import {createContext} from 'react';

import type {MediaController} from '@pexip/media';

type UserMedia = MediaController;
export const UserMediaContext = createContext<undefined | UserMedia>(undefined);
